import api from "@/services/api";
import {clearRequestIndicators, prepareRequestIndicators, successRequestIndicators} from "@/services/helper";
import getters from "@/store/getters";

export default {
    /**
     * GET A MESSAGE
     * @param commit
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    GET_BROADCAST: async ({ commit }, payload) => {
        prepareRequestIndicators(commit, true)
        try {
            const axios = api('node-api')
            const response = await axios.get(`/messages/${payload._id}`)
            
            if (response.data.broadcast) {
                commit('setBroadcast', response.data.broadcast)
                successRequestIndicators(commit, response.data.message)
                return response.data.broadcast
            }
            return null
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },
    /**
     * GET A BROADCASTS
     * @param commit
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    GET_BROADCASTS: async ({ commit }, payload) => {
        prepareRequestIndicators(commit, true)
        try {
            const axios = api('node-api')
            const response = await axios.get(`/messages/admin/all`)
            
            if (response.data.broadcasts) {
                commit('setBroadcasts', response.data.broadcasts)
                successRequestIndicators(commit, response.data.message)
                return response.data.broadcasts
            }
            return null
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },
    /**
     * POST A BROADCAST message
     * @param commit
     * @param getters
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    NEW_BROADCAST: async ({ commit, getters }, payload) => {
        prepareRequestIndicators(commit, true)
        try {
            const axios = api('node-api')
            const response = await axios.post(`/messages`, payload)
            
            if (response.data.broadcast) {
                const broadcasts = getters.broadcasts || []
                broadcasts.push(response.data.broadcast)
                
                commit('setBroadcasts', broadcasts)
                successRequestIndicators(commit, response.data.message)
                return response.data.broadcast
            }
            return null
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },

    /**
     * UPDATE A broadcast
     * @param commit
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    UPDATE_BROADCAST: async ({ commit }, payload) => {
        prepareRequestIndicators(commit, true)
        try {
            const axios = api('node-api')
            const response = await axios.put(`/messages/${payload._id}`, payload)
            
            if (response.data.broadcast) {
                commit('setBroadcast', response.data.broadcast)
                successRequestIndicators(commit, response.data.message)
                return response.data.broadcast
            }
            return null
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },



    /**
     * DELETE A broadcast
     * @param commit
     * @param getters
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    DELETE_BROADCAST: async ({ commit, getters }, payload) => {
        prepareRequestIndicators(commit, true)
        try {
            const axios = api('node-api')
            const response = await axios.delete(`/messages/${payload._id}`, payload)

            if (response.data.broadcast) {
                const broadcasts = (getters.broadcasts || []).filter((table) => {
                    if (table._id !== payload._id) {
                        return table
                    }
                })

                commit('setBroadcasts', broadcasts)
                successRequestIndicators(commit, response.data.message)
                return broadcasts
            }
            return null
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },

    /**
     * CREATE A broadcast group
     * @param commit
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    CREATE_BROADCAST_GROUP: async ({ commit }, payload) => {
        prepareRequestIndicators(commit, true)

        try {
            const axios = api('node-api')
            const response = await axios.post(`/broadcast/group`, payload)

            if (response.data.broadcast_group) {
                const groups = (getters.broadcast_groups || []).push(response.data.broadcast_group)
                commit('setBroadcastGroups', groups)

                successRequestIndicators(commit, response.data.message)
                return response.data.broadcast
            }
            return null
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },

    /**
     * DELETE A broadcast group
     * @param commit
     * @param getters
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    DELETE_BROADCAST_GROUP: async ({ commit, getters }, payload) => {
        prepareRequestIndicators(commit, true)
        try {
            const axios = api('node-api')
            const response = await axios.delete(`/broadcast/group/${payload._id}`, payload)

            if (response.data.broadcast_group) {
                const broadcasts = (getters.broadcast_groups || []).filter((table) => {
                    if (table._id !== payload._id) {
                        return table
                    }
                })

                commit('setBroadcastGroups', broadcasts)
                successRequestIndicators(commit, response.data.message)
            }
            return null
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },

    /**
     * GET broadcast group
     * @param commit
     * @param getters
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    GET_BROADCAST_GROUPS: async ({ commit, getters }, payload) => {
        prepareRequestIndicators(commit, true)
        commit('setBroadcastGroups', [])

        try {
            const axios = api('node-api')
            const response = await axios.get(`/broadcast/group`, payload)
            console.log(response.data.broadcast_groups, "response.data.broadcast_groupsresponse.data.broadcast_groupsresponse.data.broadcast_groups")

            if (response.data.broadcast_groups) {
                commit('setBroadcastGroups', response.data.broadcast_groups)
                successRequestIndicators(commit, response.data.message)
            }
            return null
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },

    /**
     * UPDATE A broadcast group
     * @param commit
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    UPDATE_BROADCAST_GROUP: async ({ commit, getters }, payload) => {
        prepareRequestIndicators(commit, true)
        try {
            const axios = api('node-api')
            const response = await axios.put(`/broadcast/group/${payload._id}`, payload)

            if (response.data.broadcast_group) {
                const broadcasts = (getters.broadcast_groups || []).filter((table) => {
                    if (table._id !== payload._id) {
                        return table
                    }
                })
                broadcasts.push(response.data.broadcast_group)
                commit('setBroadcastGroups', broadcasts)
                successRequestIndicators(commit, response.data.message)
            }
            return null
        } catch (e) {
            console.log(e)
            clearRequestIndicators(commit, true)
        }
    },

    /**
     * UPDATE message a broadcast
     * @param commit
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    MESSAGE_BROADCAST_GROUP: async ({ commit }, payload) => {
        prepareRequestIndicators(commit, true)
        try {
            const axios = api('node-api')
            const response = await axios.post(`/broadcast/group/${payload._id}/message`, payload)

            if (response.data.broadcast) {
                const broadcasts = getters.broadcasts || []
                broadcasts.push(response.data.broadcast)

                commit('setBroadcasts', broadcasts)
                successRequestIndicators(commit, response.data.message)
                return response.data.broadcast
            }
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },

    // /**
    //  * LOGIN A USER
    //  * @param commit
    //  * @param payload
    //  * @returns {Promise<void>}
    //  * @constructor
    //  */
    // LOGIN_USER: async ({ commit }, payload) => {
    //     prepareRequestIndicators(commit, true)
    //     try {
    //         const axios = api('node-api')
    //         axios.defaults.headers.common['x-id-token'] = payload.idToken
    //         delete payload.idToken
    //         const response = await axios.post(`/users/login_process`, payload)
    //
    //         if (response.data.user) {
    //             commit('setUser', response.data.user)
    //             commit('setJwt', response.data.jwt)
    //             successRequestIndicators(commit, response.data.message)
    //             return response.data.user
    //         }
    //         return null
    //     } catch (e) {
    //         clearRequestIndicators(commit, true)
    //     }
    // },
}


